import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";

function SignupPage() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [organization, setOrganization] = useState("");
  const [designation, setDesignation] = useState("");
  const [userType, setUserType] = useState("");
  const [loading, setLoading] = useState(false);

  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   // Extract client name from the URL (e.g., acme from acme.theairecruiter.ai)
  //   const clientName = window.location.hostname.split(".")[0];

  //   try {
  //     // Fetch client ID before signing up
  //     const clientIdResponse = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/client-api/clients/get-client-id?client_name=${clientName}`
  //     );

  //     const client_id = clientIdResponse.data.client_id;

  //     if (!client_id) {
  //       alert("Client ID not found. Please contact support.");
  //       return;
  //     }

  //     console.log("✅ Client ID fetched for signup:", client_id);

  //     if (password !== confirmPassword) {
  //       alert("Passwords do not match");
  //       return;
  //     }

  //     const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/auth/signup/`;
  //     const headers = {
  //       "Content-Type": "application/json",
  //     };

  //     const data = {
  //       first_name: firstName,
  //       last_name: lastName,
  //       email,
  //       phone_number: phone,
  //       password,
  //       confirmPassword,
  //       organization,
  //       designation,
  //       client: client_id, // Now dynamically fetched
  //       user_type: userType,
  //     };

  //     console.log("📨 Sending signup request:", data);
  //     const response = await axios.post(apiEndpoint, data, { headers });

  //     console.log("✅ Signup successful:", response.data);
  //     navigate("/thankyou");
  //   } catch (error) {
  //     console.error("❌ Error during signup:", error);
  //     alert("Failed to sign up. Please try again.");
  //   }
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const clientName = window.location.hostname.split(".")[0];

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    setLoading(true);

    try {
      // Initiate both API calls in parallel
      const [clientIdResponse, signupResponse] = await Promise.all([
        axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/client-api/clients/get-client-id?client_name=${clientName}`
        ),
        new Promise((resolve, reject) => {
          const signupData = {
            first_name: firstName,
            last_name: lastName,
            email,
            phone_number: phone,
            password,
            confirmPassword,
            organization,
            designation,
            user_type: userType,
          };

          resolve(signupData);
        }),
      ]);

      const client_id = clientIdResponse.data.client_id;

      if (!client_id) {
        alert("Client ID not found. Please contact support.");
        return;
      }

      // console.log("✅ Client ID fetched for signup:", client_id);

      const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/auth/signup/`;
      const headers = { "Content-Type": "application/json" };

      // Add client ID dynamically
      const finalData = { ...signupResponse, client: client_id };

      // console.log("📨 Sending signup request:", finalData);
      const response = await axios.post(apiEndpoint, finalData, { headers });

      // console.log("✅ Signup successful:", response.data);
      navigate("/thankyou");
    } catch (error) {
      console.error("❌ Error during signup:", error);
      alert("Failed to sign up. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <NavbarForOnboardingForm />

      <div className="container py-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
            <div
              className="card shadow-lg border  bg-transparent"
              style={{ borderRadius: "15px", overflow: "hidden" }}
            >
              <div
                className="card-header border-dark text-white"
                style={{ background: "#008cba" }}
              >
                <h3 className="text-center">Sign Up</h3>
              </div>
              <div className="card-body text-dark">
                <form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="firstName">
                            First Name
                          </label>
                          <input
                            type="text"
                            id="firstName"
                            className="form-control border-dark text-dark"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="lastName">
                            Last Name
                          </label>
                          <input
                            type="text"
                            id="lastName"
                            className="form-control border-dark text-dark"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="email" className="form-label">
                          Email address
                        </label>
                        <input
                          type="email"
                          className="form-control border-dark text-dark"
                          id="email"
                          aria-describedby="emailHelp"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="phone" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          className="form-control border-dark text-dark"
                          id="phone"
                          aria-describedby="emailHelp"
                          pattern="(\+91)?[6-9][0-9]{9}"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <div className="input-group">
                          <input
                            type="password"
                            className="form-control border-dark text-dark"
                            id="password"
                            pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,}"
                            title="Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character, and must be at least 8 characters long."
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="confirmPassword"
                          className="form-label text-dark"
                        >
                          Confirm Password
                        </label>
                        <div className="input-group">
                          <input
                            type="password"
                            className="form-control border-dark text-dark"
                            id="confirmPassword"
                            name="confirmPassword"
                            aria-describedby="emailHelp"
                            //pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,}"
                            //title="Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character, and must be at least 8 characters long."
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="organization" className="form-label">
                          Organization
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="organization"
                          aria-describedby="emailHelp"
                          value={organization}
                          onChange={(e) => setOrganization(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="designation" className="form-label">
                          Designation
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="designation"
                          aria-describedby="emailHelp"
                          value={designation}
                          onChange={(e) => setDesignation(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">User Type</label>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="admin"
                            name="userType"
                            value="admin"
                            className="form-check-input border-dark"
                            onChange={(e) =>
                              setUserType(e.target.value.toLowerCase())
                            }
                            required
                          />
                          <label className="form-check-label" htmlFor="admin">
                            Admin
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="hr"
                            name="userType"
                            value="hr"
                            className="form-check-input border-dark"
                            onChange={(e) =>
                              setUserType(e.target.value.toLowerCase())
                            }
                            required
                          />
                          <label className="form-check-label" htmlFor="hr">
                            HR
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="manager"
                            name="userType"
                            value="manager"
                            className="form-check-input border-dark"
                            onChange={(e) =>
                              setUserType(e.target.value.toLowerCase())
                            }
                            required
                          />
                          <label className="form-check-label" htmlFor="manager">
                            Manager
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="recruiter"
                            name="userType"
                            value="recruiter"
                            className="form-check-input border-dark"
                            onChange={(e) =>
                              setUserType(e.target.value.toLowerCase())
                            }
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="recruiter"
                          >
                            Recruiter
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="text-center">
                    <button
                      type="submit"
                      disabled={loading}
                      className="btn mb-2 btn-outline-info"
                    >
                      {loading ? "Signing up..." : "Sign Up"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignupPage;
